import type { Theme } from "theme-ui";

export const text: Theme["text"] = {
  heading: {
    fontFamily: "heading",
    fontWeight: 700,
    lineHeight: 1.1,
  },
};
